import axios from 'axios'
import router from '@/router'
import store from "@/store";
// 创建axios实例
const service=axios.create({
  timeout:1000*30,
  withCredentials:true,
  headers:{
    'Content-Type':'application/json;charset=utf-8',
    'Accept-Language':'zh',
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    'Pragma': 'no-cache',
    'Expires': '0'
  }
});

// http request 拦截器
service.interceptors.request.use(
  config => {
    let loginToken=localStorage.getItem('loginToken');
    if (loginToken) {// 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.token = loginToken;
    }
    let language = store.state.lang
    if(language != null){
      config.headers['Accept-Language'] = language;
    }

    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

// http response 拦截器
service.interceptors.response.use(
  response => {
    let res=response.data;
    if (res && res.code===401) {
      // 返回 401 清除token信息并跳转到登录页面
      localStorage.removeItem('loginToken');
      localStorage.removeItem('nickname');
      router.replace({
        path: '/'
      })
    }
    return response;

  },
  error => {
    return Promise.reject(error)// 返回接口返回的错误信息
  });

  service.all=axios.all;
  service.spread =axios.spread;


export default service



// WEBPACK FOOTER //
// ./src/axios/index.js